import React from 'react';
import { Loader2, CheckCircle, AlertCircle } from 'lucide-react';
import { formatTime } from '../utils/formatDate';

interface SaveStatusIndicatorProps {
  isSaving: boolean;
  lastSaved: Date | null;
  error?: string | Error | null;
}

export const SaveStatusIndicator: React.FC<SaveStatusIndicatorProps> = ({
  isSaving,
  lastSaved,
  error,
}) => {
  if (error) {
    const message = error instanceof Error ? error.message : error;
    return (
      <div className="flex items-center gap-1.5 text-sm text-red-600">
        <AlertCircle size={14} />
        <span>Save failed{message ? `: ${message}` : ''}</span>
      </div>
    );
  }

  if (isSaving) {
    return (
      <div className="flex items-center gap-1.5 text-sm text-gray-500">
        <Loader2 size={14} className="animate-spin" />
        <span>Saving...</span>
      </div>
    );
  }

  if (lastSaved) {
    return (
      <div className="flex items-center gap-1.5 text-sm text-gray-500">
        <CheckCircle size={14} className="text-green-500" />
        <span>Saved at {formatTime(lastSaved)}</span>
      </div>
    );
  }

  return null;
};
